import { Navigate, useLocation, useParams } from 'react-router-dom';

// Old admin URLs and where they land since the admin overhaul (Phases 2 and 3).

// Old Advisory Board links: members go to Advisors, applications and reviews to the Messages inbox.
export function AdvisoryBoardRedirect() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const tab = params.get('tab');
  if (tab === 'members') return <Navigate to="/admin/messages/advisors" replace />;
  const keep = new URLSearchParams();
  for (const key of ['reviewId', 'feedbackId']) {
    const value = params.get(key);
    if (value) keep.set(key, value);
  }
  const query = keep.toString();
  return <Navigate to={`/admin/messages${query ? `?${query}` : ''}${tab === 'applications' ? '#applications' : ''}`} replace />;
}

// The old program list is the Library now; keep the query (program previews return here).
export function ProgramsListRedirect() {
  const location = useLocation();
  return <Navigate to={`/admin/library${location.search}`} replace />;
}

// Old email links keep their sub-page and query under Messages.
export function EmailsRedirect() {
  const location = useLocation();
  const rest = location.pathname.replace(/^\/admin\/emails/, '');
  return <Navigate to={`/admin/messages/emails${rest}${location.search}`} replace />;
}

// Old admin user links (/admin/users/:id, profile or user id) open that person in People.
export function AdminUserRedirect() {
  const { userId } = useParams();
  return <Navigate to={userId ? `/admin/people?open=${encodeURIComponent(userId)}` : '/admin/people'} replace />;
}
